module.exports = __webpack_public_path__ + "c8f8e943f278111566be5c51b895f96f.svg";